module.exports = __webpack_public_path__ + "fonts/2c5688c2d6c7687e323e6b39f9ca3ac5.svg";